import Immutable, { Record, List } from 'immutable';

const UnitRecord = Record({
  id: undefined,
  name: undefined,
  sessionPlanIds: new List(),
});

class Unit extends UnitRecord { }

const reviver = ([key, seq]) => {
  if (! seq) return [key, seq];
  return [key, Immutable.fromJS(seq)];
};

Unit.create = (data) =>
  new Unit(data).mapEntries(reviver);

export default Unit;



// WEBPACK FOOTER //
// ./data/ProgressTests/Units/model.js